import { notifications } from '@mantine/notifications';
import {
  getBankAccountKey,
  getBankAccountsKey,
  useGetBankAccount,
  useUpdateBankAccount,
} from 'api-hooks/bank-account';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import BankAccountForm from './components/form';

export type BankAccountViewParams = {
  id: string;
};

export default function BankAccountView(
  props: NavigationProps<NavigationRoutes.BankAccountsView>,
) {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetBankAccount({ id }, { enabled: !!id });
  const updateMutation = useUpdateBankAccount();

  return (
    <BankAccountForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          bankAccountId: id,
          body: input,
        });

        queryClient.refetchQueries(getBankAccountsKey());
        queryClient.refetchQueries(getBankAccountKey({ id }));

        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
